import { connect } from 'react-redux';

import {
    mapDispatchToProps,
    mapStateToProps,
    WishlistSharedPageContainer as SourceWishlistSharedPageContainer,
} from 'SourceRoute/WishlistSharedPage/WishlistSharedPage.container';

export { mapDispatchToProps, mapStateToProps };
/** @namespace Pwa/Route/WishlistSharedPage/Container */
export class WishlistSharedPageContainer extends SourceWishlistSharedPageContainer {
    containerProps() {
        const { creatorsName, wishlistItems, isLoading, isWishlistLoading } = this.state;

        const isWishlistEmpty = this._getIsWishlistEmpty();
        return {
            isWishlistLoading,
            isWishlistEmpty,
            isLoading,
            creatorsName,
            wishlistItems,
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WishlistSharedPageContainer);
